<template>
  <div>
    <div class="loadBalancingResourceAzure-title">
      <div>{{ $t("RAM.Azure.loadBalance.title") }}</div>
      <div>
        <Button
          type="primary"
          v-hasPermission="[
            'resourceConfigurationManagement:azure:loadBalance:update'
          ]"
          :loading="loading"
          @click="update"
          >{{ $t("RAM.common.update") }}</Button
        >
        <Button
          type="primary"
          v-hasPermission="[
            'resourceConfigurationManagement:azure:loadBalance:export'
          ]"
          :loading="modal_loading"
          @click="exportList"
          >{{ $t("common.export") }}</Button
        >
      </div>
    </div>
    <div class="loadBalancingResourceAzure-top">
      <load-balancing-resource-azure-search
        ref="search"
      ></load-balancing-resource-azure-search>
    </div>
    <table-load-balancing-resource-azure></table-load-balancing-resource-azure>
  </div>
</template>

<script>
import LoadBalancingResourceAzureSearch from "../loadbalance/LoadBalancingResourceAzureSearch";
import TableLoadBalancingResourceAzure from "../loadbalance/TableLoadBalancingResourceAzure";

export default {
  name: "LoadBalancingResourceAzure",
  components: {
    LoadBalancingResourceAzureSearch,
    TableLoadBalancingResourceAzure
  },
  data() {
    return {
      loading: false,
      modal_loading: false,
      companyId: ""
    };
  },
  methods: {
    update: function() {
      this.loading = true;
      this.companyId = this.$refs.search.companyId;

      this.$api.resourceManagement
        .updateResource({
          companyId: this.companyId,
          resourceManagement: 206
        })
        .then(res => {
          this.loading = false;
          setTimeout(() => {
            this.$Message.success(this.$t('common.updateSuccess'));
          }, 1000);
        });
    },
    //导出
    exportList: function() {
      this.modal_loading = true;
      this.$Message.loading({
        duration: 0,
        content: this.$t('common.exporting')
      });
      this.companyId = this.$refs.search.companyId;
      // 下载Excel 文件
      this.$api.resourceManagement
        .exportAzureLoadBalance({
          companyId: this.companyId
        })
        .then(res => {
          let fileName = this.$t('RAM.export.azureLoadBalance');
          let blob = new Blob([res.data], { type: "application/x-xls" });
          if (window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(blob, fileName);
          } else {
            var link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = fileName;
            link.click();
            window.URL.revokeObjectURL(link.href);
          }
          this.modal_loading = false;
          this.$Message.destroy();
          this.$Message.success(this.$t('common.exportSuccess'));
        });
    }
  }
};
</script>

<style scoped>
.loadBalancingResourceAzure-title {
  width: 100%;
  font-size: 13px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 15px 0px 0px 4px;
  font-weight: 600;
  overflow: hidden;
}
.loadBalancingResourceAzure-title > div:nth-child(1) {
  float: left;
}
.loadBalancingResourceAzure-title > div:nth-child(2) {
  float: right;
  margin-top: -6px;
}
.loadBalancingResourceAzure-top {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/resource_configuration_management/azure/loadbalance/LoadBalancingResourceAzure.vue